import React, { useState, useEffect } from 'react';
import { Phone, Copy, Check } from 'lucide-react';

const ContactWidget = ({
  phoneNumber = "088 6882 799",
  position = 'left',
  ismobile = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isRinging, setIsRinging] = useState(false);

  const normalizedPhone = phoneNumber.replace(/\s+/g, '');

const handleCall = () => {
  window.location.href = `tel:${normalizedPhone}`;
};

  // Auto ring animation every 5 seconds
  useEffect(() => {
    const ringInterval = setInterval(() => {
      if (!isHovered) {
        setIsRinging(true);
        setTimeout(() => setIsRinging(false), 1000);
      }
    }, 2000);

    return () => clearInterval(ringInterval);
  }, [isHovered]);

  const handleCopyPhone = async () => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy phone number:', err);
    }
  };

  const positionClasses = position === 'left'
    ? 'left-6'
    : 'right-6';

  return (
    <div
      className={`fixed ${positionClasses} ${ismobile ? 'bottom-28' : 'bottom-6'} z-50 flex items-center group`}
    >
      {/* Phone Number Card */}
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          bg-white rounded-full shadow-lg border border-gray-200 px-4 py-3
          transform transition-all duration-300 ease-out
          absolute left-0 top-1/2 -translate-y-1/2
          ${isHovered && !ismobile
            ? 'translate-x-16 opacity-100 scale-100'
            : 'hidden translate-x-0 opacity-0 scale-95'
          }
          ${position === 'right' ? 'right-[8rem] left-auto translate-x-0' : ''}
          ${position === 'right' && isHovered ? '-translate-x-16' : ''}
        `}
      >
        <div className="flex items-center space-x-3">
          <span className="text-gray-700 font-medium whitespace-nowrap">
            {phoneNumber}
          </span>
          <button
            onClick={handleCopyPhone}
            className={`
              p-1.5 rounded-full transition-all duration-200
              ${isCopied
                ? 'bg-green-100 text-green-600'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-600'
              }
            `}
            title={isCopied ? "Đã copy!" : "Copy số điện thoại"}
          >
            {isCopied ? (
              <Check className="w-4 h-4" />
            ) : (
              <Copy className="w-4 h-4" />
            )}
          </button>
        </div>
      </div>

      {/* Main Phone Icon Button */}
      <div className="relative"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}>
        <div
          className={`
            absolute inset-0 bg-green-500 rounded-full
            transform transition-all duration-1000 ease-out
            ${isHovered ? 'scale-150 opacity-0' : 'scale-100 opacity-20'}
          `}
        />

        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20" />

        <a
  href={`tel:${phoneNumber.replace(/\s+/g, '')}`}
  className={`
    relative bg-gradient-to-r from-green-500 to-green-600 
    rounded-full shadow-lg flex items-center justify-center
    transform transition-all duration-300 ease-out
    hover:scale-110 hover:shadow-xl
    ${!ismobile ? 'w-14 h-14' : 'w-12 h-12'}
  `}
>
  <img
    src="/phone-white.svg"
    className="w-5 h-5 md:w-6 md:h-6 text-white"
    style={{
      animation: isRinging ? 'iconTiltSoft 0.8s ease-in-out 1' : undefined,
      transformOrigin: '50% 55%',
    }}
  />
</a>
      </div>
    </div>
  );
};

export default ContactWidget;
